"use client";

interface ContactFeedbackSectionProps {
  title?: string;
  body?: string;
}

export default function ContactFeedbackSection({
  title = "Send Feedback or Share an Idea",
  body,
}: ContactFeedbackSectionProps) {
  const paragraphs = (body ?? "")
    .split(/\n{2,}/)
    .map((paragraph) => paragraph.trim())
    .filter(Boolean);

  if (!title.trim() && !paragraphs.length) return null;

  return (
    <section className="mb-20 max-w-4xl md:mx-auto mx-5" aria-label={title}>
      <div className="px-6 sm:px-14">
        {title.trim() ? (
          <h2 className="text-2xl font-bold text-[#F5F5F5]">{title}</h2>
        ) : null}
        {paragraphs.length ? (
          <div className="mt-10 space-y-8 text-lg leading-7 text-[#F5F5F5]/90">
            {paragraphs.map((paragraph, index) => (
              <p key={index}>{paragraph}</p>
            ))}
          </div>
        ) : null}
      </div>
    </section>
  );
}
